export default () => ({
    countryCode: null
});
